export default "__VITE_ASSET__CSfF$r84__"